import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import EllipsisHover from '@/pages/home/components/EllipsisHover';
import './index.scss';

interface Props {
  label?: string;
  value: string[];
  options: any[];
}

const SelectButton = (props: Props) => {
  const { label, options = [], value = [] } = props;

  const { formatMessage } = useIntl();

  const text = useMemo<string>(() => {
    if (!Array.isArray(value) || !value?.length) return formatMessage({ id: 'dbi_please_select' });
    if (options?.length && options?.length === value?.length) return formatMessage({ id: 'dbi_all' });
    if (value?.length >= 3) return value?.length?.toString(10);
    return value
      .map((item) => {
        const option = options?.find((subItem) => subItem?.value === item);
        return option?.label || option?.text || option?.value || item || '';
      })
      .join(', ');
  }, [value, options]);

  return (
    <div className="select-result-button">
      <span className="select-result-button-label">{label ? label : ''}</span>
      <span className="select-result-button-content">
        <EllipsisHover text={text} />
      </span>
    </div>
  );
};

export default SelectButton;
